import { useMemo } from 'react';
import { Switch, SwitchProps } from '@mantine/core';
import { headings } from '@ui/tokens/typography/typography';

const SWITCH_STYLES = {
	root: {
		borderBottom: '1px solid var(--color-outline-default)',
		paddingBottom: '8px'
	},
	track: {
		minWidth: '40px'
	},
	body: {
		gap: '30px',
		justifyContent: 'space-between'
	},
	label: {
		...headings.h5
	}
}

const PermissionsSwitch = ( { styles = {}, ...props }: SwitchProps ) => {
	const switchStyles = useMemo( () => ( { ...SWITCH_STYLES, ...styles } ), [ styles ] );

	return (
		<Switch
			styles={switchStyles}
			labelPosition="left"
			{...props}
		/>
	);
};

export default PermissionsSwitch;
